import api from './index';

export interface DashboardData {
  vehicles: number;
  activeVehicles: number;
  vehiclesInMaintenance: number;
  employees: number;
  incidents: number;
  alerts: number;
  fuelings: number;
  totalFuelCost: number;
  totalMaintenanceCost: number;
  pendingRequests: number;
  trips: number;
  totalTripDistance: number;
}

export const dashboardService = {
  async getDashboard(): Promise<DashboardData> {
    const res = await api.get('/dashboard');
    return res.data;
  },
};
